import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {StoreLink} from './store-link.js'

const DOWNLOAD_APP_LINK_EVENT_NAME = platform => `${platform} App Downloaded`

const LinkStores = ({hasShadow = false}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const {
    stores: {itunes, gplay}
  } = config.get('links')
  const {url: ITUNES_URL, text: ITUNES_TEXT} = itunes
  const {url: GPLAY_URL, text: GPLAY_TEXT} = gplay
  const BASE_CLASS = 'mt-LinkStores'
  const SHADOW_CLASS = `${BASE_CLASS}--hasShadow`
  const ITUNES_LINK_CLASS = `${BASE_CLASS}-item ${BASE_CLASS}-item--itunes`
  const GPLAY_LINK_CLASS = `${BASE_CLASS}-item ${BASE_CLASS}-item--gplay`

  const linkStoresClassNames = cx(BASE_CLASS, {
    [SHADOW_CLASS]: hasShadow
  })

  const {track} = useAnalyticsTrack()

  const handleClick = platform => {
    track({event: DOWNLOAD_APP_LINK_EVENT_NAME(platform)})
  }

  return (
    <div className={linkStoresClassNames}>
      <StoreLink
        href={ITUNES_URL}
        title={ITUNES_TEXT}
        className={ITUNES_LINK_CLASS}
        onClick={() => handleClick('IOS')}
        platform="IOS"
      />
      <StoreLink
        href={GPLAY_URL}
        title={GPLAY_TEXT}
        className={GPLAY_LINK_CLASS}
        onClick={() => handleClick('Android')}
        platform="Android"
      />
    </div>
  )
}

LinkStores.displayName = 'LinkStores'

LinkStores.propTypes = {
  hasShadow: PropTypes.bool
}

export default LinkStores
